import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import UssdPhoneSimulator from './UssdPhoneSimulator';
import { useTelemetry } from '../context/TelemetryContext';

const LayoutContent = () => {
  const { isSimulatorDrawerOpen, setIsSimulatorDrawerOpen, loadDashboardData } = useTelemetry();

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg-base)', width: '100%' }}>
      {/* 1. Collapsible Left Navigation Sidebar */}
      <Sidebar />

      {/* 2. Main Content Area */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        
        {/* Global Header */}
        <div style={{ padding: '20px 32px 0 32px' }}>
          <Header />
        </div>

        {/* Dynamic Page Content */}
        <main style={{ padding: '24px 32px 64px 32px', flex: 1, overflowX: 'hidden' }}>
          <Outlet />
        </main>

        {/* Minimal Footer */}
        <footer style={{
          padding: '16px 32px',
          borderTop: '1px solid var(--border-subtle)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '12px',
          color: 'var(--text-muted)',
          background: 'rgba(7, 9, 14, 0.8)'
        }}>
          <div>© {new Date().getFullYear()} CestaSoft CestaConnect. All rights reserved.</div>
          <div style={{ display: 'flex', gap: '16px' }}>
            <span>USSD Mediator v1.0.0</span>
            <span>Enterprise Gateway</span>
          </div>
        </footer>

      </div>

      {/* 3. Slide-over Phone Sandbox Drawer (Available globally across all pages) */}
      <UssdPhoneSimulator
        isOpen={isSimulatorDrawerOpen}
        onClose={() => setIsSimulatorDrawerOpen(false)}
        onSessionCompleted={() => {
          setTimeout(loadDashboardData, 800);
        }}
      />
    </div>
  );
};

export default function Layout() {
  return <LayoutContent />;
}